<script>
  import CarouselSwipe from "../tpls/CarouselSwipe.svelte";
  // import CarouselSwiper from '../tpls/CarouselSwiper.svelte';
  export let config = {};
  export let data = {};
</script>

<style>
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    column-gap: 40px;
    align-items: center;
  }
  .portrait {
    padding: 80px 40px;
  }
  .portrait img {
    max-width: 100%;
    max-height: 460px;
    width: auto;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .txt1 {
    padding-right: 10px;
  }
  .txt2 {
    padding-left: 10px;
  }
</style>

<section class={config.class} data-section="columns">
  <div class="layout grid">
    {#each data.cols as col}
      {#if col.config.tpl === 'txt'}
        <div class={col.config.class}>
          {@html col.data.html}
        </div>
      {:else if col.config.tpl === 'img'}
        <div class={col.config.class}>
          <img src={col.data.img.src} alt={col.data.img.alt} />
        </div>
      {:else if col.config.tpl === 'imgs'}
        <div>
          <CarouselSwipe data={col.data.imgs} />
          <!-- <CarouselSwiper data={col.data.imgs} /> -->
        </div>
      {/if}
    {/each}
  </div>
</section>
